import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Arthur is one of DDD Taiwan Community organizers, and he also does many product development methodology research. He hopes finally he can find a perfect product development roadmap.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      